import { IApplicationState } from '../../types/redux';

export const selectQualityLevelInfo = (state: IApplicationState) => state.qualityLevelInfo;
